/**
 * Test IDs for QA automation.
 */
export const testIds = {
  billingRulesEditorAddRule: "billing-rules-editor-add-rule",
} as const;
